import { Box, HStack, Image, Text, VStack } from "native-base";
import CustomButton from "../../../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import MobileHeader from "../../../../layout/header/mobileHeader";
import "./style.css";

const CventMobileLandingPageBanner = () => {
  function bannerText() {
    return (
      <VStack alignItems={"center"} justifyContent={"center"} px={4}>
        <Text
          fontSize={"24px"}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          pt={2}
          textAlign={"center"}
        >
          Looking for a better event planner?
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          textAlign={"center"}
          mt={1}
          mb={6}
          mx={8}
        >
          Cvent makes your life simple with minimal clicks
        </Text>
        <Box>
          <a
            style={{ textDecoration: "none" }}
            href="https://www.cvent.com/in"
            target="_blank"
            rel="noopener noreferrer"
          >
            <CustomButton
              onClick={() => window.open("https://www.cvent.com/in", "_blank")}
              text="Connect with Cvent"
              width="fit-content"
              py="10px"
            />
          </a>
        </Box>
      </VStack>
    );
  }
  return (
    <>
      <MobileHeader showTabs={true} />
      {/* <div className="cvent-landing-page-banner-container">
        <HStack flex={1} w="100%" h="100%" direction={"column"} py={"4px"}>
          <Box w={"100%"} alignItems={"center"} pt={5}>
            <Image
              source={{
                uri: require("../../../../utils/quickLinkImages/cvent-banner-web.png"),
              }}
              alt="image"
              width="247px"
              minH="161px"
            />
          </Box>
          <Box w={"100%"} pt={6} pb={"2rem"}>
            {bannerText()}
          </Box>
        </HStack>
      </div> */}
    </>
  );
};

export default CventMobileLandingPageBanner;
